$(document).ready(function () {
    $("input[type='file']:not(#input)").change(function(){
        console.info('input changed');
        readURL(this);
    });
});

function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();
        
        reader.onload = function (e) {
            $(input).parent().find('img').attr('src', e.target.result);
        }
        
        reader.readAsDataURL(input.files[0]);
    }
}
